import { render, staticRenderFns } from "./ElementHeader.vue?vue&type=template&id=8d3e458a&scoped=true"
import script from "./ElementHeader.vue?vue&type=script&lang=js"
export * from "./ElementHeader.vue?vue&type=script&lang=js"
import style0 from "./ElementHeader.vue?vue&type=style&index=0&id=8d3e458a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3e458a",
  null
  
)

export default component.exports